import Vue from 'vue';
import Projects from '@/resources/projects';
import Substations from '@/resources/substations';
import jsona from '@/lib/jsona';
import RootStateCommit from '@/store/mixins/rootstate-commit';

const MODULE_NAME = 'projectSubstations';
const DEFAULT_STATE = {
  error: null,
  project: null
};

const changeSubstationAndUpdateState = (state, substationCode, attributes) => {
  const substationIndex = state.project.substations.findIndex(el => el.code === substationCode);
  const newSubstation = { ...state.project.substations[substationIndex], ...attributes };
  Vue.set(state.project.substations, substationIndex, newSubstation);
};

export default {
  namespaced: true,
  state: { ...DEFAULT_STATE },
  /* eslint no-param-reassign: ["error", { "props": false }] */
  mutations: {
    parseResponseData(state, response) {
      state.project = jsona.deserialize(response);
    },
    resetStore(state) {
      Object.assign(state, DEFAULT_STATE);
    },
    removeSubstation(state, substationCode) {
      changeSubstationAndUpdateState(state, substationCode, { removed: true });
    },
    markSubstationAsPermanentlyRemoved(state, substationCode) {
      changeSubstationAndUpdateState(state, substationCode, { permanentlyRemoved: true });
    },
    rollbackRemoveSubstation(state, substationCode) {
      changeSubstationAndUpdateState(state, substationCode, { removed: false });
    }
  },
  actions: {
    async fetchData({ commit }, { projectCode }) {
      RootStateCommit(commit, 'startLoading', MODULE_NAME);

      try {
        const response = await Projects.get({
          code: projectCode,
          include: 'substations,substations.amp2,substations.visnet_hubs'
        });

        if (!response) {
          RootStateCommit(commit, 'setResponseError', MODULE_NAME);
          throw Error;
        }
        commit('parseResponseData', response.data);
        RootStateCommit(commit, 'stopLoading', MODULE_NAME);

        return response.ok;
      } catch (error) {
        RootStateCommit(commit, 'setResponseError', MODULE_NAME);

        return error.ok;
      }
    },
    removeProject({ commit }, { projectCode, substationCode }) {
      commit('removeSubstation', substationCode);
      Substations({ projectCode })
        .delete({ code: substationCode })
        .then(
          () => commit('markSubstationAsPermanentlyRemoved', substationCode),
          () => commit('rollbackRemoveSubstation', substationCode)
        );
    }
  }
};
